import { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import qs from "query-string";

import { routes, URL_API_SHORT_LINK } from "../../../constants";
import { api, getApiErrorMessage } from "../../../helpers";

import Alert from "../../../styles/components/Alert";
import Article from "../../../styles/components/Article";
import ErrorBoundary from "../../error-boundary";
import ErrorBoundaryFallbackApp from "../../error-boundary/components/ErrorBoundary.fallback-app";

class AppShortLink extends Component {
  constructor(props) {
    super(props);

    this.getShortLinkData = this.getShortLinkData.bind(this);
    this.handleApiError = this.handleApiError.bind(this);
    this.throwError = this.throwError.bind(this);

    this.state = {
      error: null,
      redirect: null,
    };
  }

  /**
   * Get Short Link Data
   * @public
   */
  getShortLinkData() {
    const { handleApiError } = this;
    const { action, hash } = this.props.computedMatch.params;
    const url = `${URL_API_SHORT_LINK}/${hash}/${action}`;

    api
      .get(url)
      .then(response => {
        if (!!response.data && !!response.data.listing_data) {
          const { listing_data, ...rest } = response.data;
          const listing =
            typeof listing_data === "string"
              ? JSON.parse(listing_data)
              : listing_data;
          this.setState({
            redirect: {
              pathname: `/${listing.slug}`,
              state: { ...rest, action: action, hash: hash },
            },
          });
        } else if (!!response.data && !!response.data.filters) {
          const { filters, ...rest } = response.data;
          const query =
            typeof filters === "string" ? JSON.parse(filters) : filters;
          this.setState({
            redirect: {
              pathname: routes.compile.path,
              search: qs.stringify(query),
              state: { ...rest, action: action, hash: hash },
            },
          });
        } else {
          handleApiError(response);
        }
      })
      .catch(handleApiError);
  }

  /**
   * Handle API error
   * @param {*}
   * @public
   */
  handleApiError(error) {
    const message = getApiErrorMessage(error);
    const userFriendlyError = new Error(message);
    if (!!error && !!error.stack) {
      userFriendlyError.stack += `\nCaused by: ${error.stack}`;
    }

    this.setState({ error: userFriendlyError });
  }

  /**
   * Throw error during render so it gets passed to the ErrorBoundary
   * @param {*}
   * @public
   */
  throwError = error => {
    if (error instanceof Error) {
      throw error;
    }
  };

  componentDidMount() {
    const { location, computedMatch: match } = this.props;

    if (!!match && !!match.params) {
      const { action, hash } = match.params;

      switch (action) {
        case "pdf":
        case "zip":
          this.setState({
            redirect: {
              pathname: `${routes.download.path}/${hash}`,
              state: {
                shortLink: true,
                shortLinkAction: action,
              },
            },
          });
          break;
        case "clone":
        case "edit":
        case "read":
          this.getShortLinkData();
          break;
        default:
          this.setState({
            redirect: {
              pathname: routes.notFound.path,
              state: {
                notFound: !!location && location.pathname,
              },
            },
          });
          break;
      }
    }
  }

  render() {
    const { error, redirect } = this.state;

    return (
      <ErrorBoundary
        location="app-short-link"
        fallback={ErrorBoundaryFallbackApp}
      >
        <Route
          {...this.props}
          render={props =>
            !!redirect ? (
              <Redirect to={redirect} />
            ) : (
              <Article>
                {!!error && this.throwError(error)}
                <Alert>Loading…</Alert>
              </Article>
            )
          }
        />
      </ErrorBoundary>
    );
  }
}

export default AppShortLink;
